var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.375 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.188,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 30.976c0-2.708-2.258-4.889-5.062-4.889s-5.062 2.18-5.062 4.889v20.671c0 2.708 2.258 4.889 5.062 4.889S70 54.355 70 51.647zm-59.876 0c0-2.708-2.258-4.889-5.062-4.889S0 28.267 0 30.976v20.671c0 2.708 2.258 4.889 5.062 4.889s5.062-2.18 5.062-4.889zm21.405 33.241v10.894c0 2.708-2.258 4.889-5.062 4.889s-5.062-2.18-5.062-4.889V64.217h-3.471q-5.496-.279-5.785-5.587V26.785h45.703V58.63q-.145 5.308-5.785 5.587h-3.471v10.894c0 2.708-2.258 4.889-5.062 4.889s-5.062-2.18-5.062-4.889V64.217zm-7.778-56.91c-6.456 3.055-11.318 8.987-11.602 17.803l45.703-.14c-.375-8.694-5.22-14.57-11.626-17.622l3.622-6.31c.194-.338.069-.762-.282-.949s-.789-.066-.983.272l-3.678 6.407c-6.21-2.511-13.627-2.525-19.832-.038L21.417.36c-.194-.338-.633-.46-.983-.272s-.476.611-.282.949zm-1.189 7.886c0-1.006.839-1.816 1.88-1.816s1.88.81 1.88 1.816-.839 1.816-1.88 1.816-1.88-.81-1.88-1.816zm21.116 0c0-1.006.839-1.816 1.88-1.816s1.88.81 1.88 1.816-.839 1.816-1.88 1.816-1.88-.81-1.88-1.816z",
    fill: "#77c159",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.28817f190f9b983e263bb7f0eb129d2a.svg";
export { ForwardRef as ReactComponent };